import React from "react"
import { renderToStaticMarkup } from "react-dom/server"
import tw, { styled, css, TwStyle } from "twin.macro"
import { ReactComponent as CheckSVG } from "../../../assets/icons/check.svg"

export interface CheckboxProps {
  checked: boolean
  label: string
  name: string
  handleChange: () => void
  disabled?: boolean
  testId?: string
  inputId?: string
  tabIndex?: number
  twStyle?: TwStyle | string
}

const Check = encodeURIComponent(renderToStaticMarkup(<CheckSVG />))
export interface StyledLabelProps {
  checked: boolean
  disabled?: boolean
}
export const StyledLabel = styled.label(({ checked, disabled }: StyledLabelProps) => [
  tw`relative pl-8 cursor-pointer font-medium`,
  css`
    &:before {
      content: " ";
      ${tw`bg-white w-[24px] h-[24px] border border-purple rounded absolute -top-0.5 left-0`}
      ${disabled && tw`border-light-purple cursor-default`}
    }
  `,
  checked && [
    css`
      &:before {
        background: url("data:image/svg+xml,${Check}") no-repeat center center;
        ${tw`bg-purple`}
      }
    `,
  ],
  disabled ? tw`text-base-3` : "",
])

export const Checkbox = ({
  handleChange,
  checked,
  disabled,
  label,
  name,
  testId,
  inputId,
  tabIndex,
  twStyle,
}: CheckboxProps) => {
  const uniqueInputId = !!inputId ? inputId : `${name}_id`

  return (
    <div tw="py-2.5 w-full relative max-w-72 mx-auto flex" css={twStyle}>
      <div>
        <input
          tw="absolute right-auto left-[-9999px]"
          disabled={disabled}
          type="checkbox"
          checked={checked}
          name={name}
          data-testid={testId}
          id={uniqueInputId}
          onChange={handleChange}
          tabIndex={tabIndex}
        />
        <StyledLabel
          htmlFor={uniqueInputId}
          checked={checked}
          disabled={disabled}
          dangerouslySetInnerHTML={{ __html: `${label}` }}
        />
      </div>
    </div>
  )
}
